export function getPahtIndex(Router, pathList) {
  let path = Router.fullPath
  let index = pathList.findIndex((value, index, arr) => {
    return value === path
  })
  return index
}

export function formatDateTime(inputTime) {
  var date = new Date(inputTime);
  var y = date.getFullYear();
  var m = date.getMonth() + 1;
  m = m < 10 ? ('0' + m) : m;
  var d = date.getDate();
  d = d < 10 ? ('0' + d) : d;
  var h = date.getHours();
  h = h < 10 ? ('0' + h) : h;
  var minute = date.getMinutes();
  var second = date.getSeconds();
  minute = minute < 10 ? ('0' + minute) : minute;
  second = second < 10 ? ('0' + second) : second;
  return y + '-' + m + '-' + d + ' ' + h + ':' + minute + ':' + second;
}

export function formatBirthDate(y,m,d) {
  m = m < 10 ? ('0' + m) : m;
  d = d < 10 ? ('0' + d) : d;
  return y + '-' + m + '-' + d;
}

export function getScore(modelVal,type) {
  let point = {
    a:{'0':'6', '1':'4', '2':'2', '3':'0'},   //a:{'对应model的值'：'对应的分数',......}
    b:{'0':'0', '1':'2'},
    c:{'0':'0', '1':'3', '2':'5'},
    d:{'0':'1', '1':'0'},
    e:{'0':'1', '1':'0','2':'0'}
  }
  let result = Number(point[type][modelVal]);
  result = Boolean(result)?result:0;
  return result;
}


export function getURLParams(url, type) {
  let str = ''
  if (url.substr(1).toLowerCase().indexOf(type + '=') !== -1) {
      let urlParameter = url.substr(1);
      if (urlParameter.indexOf('&') !== '-1') {
          let arr = urlParameter.split('&');
          arr.forEach(item => {
              if (item.toLowerCase().indexOf(type + '=') !== -1) {
                  str = item.split('=')[1].toLowerCase();
                  str = str.replace('main_', '');
              }
          })
      } else {
          if (item.toLowerCase().indexOf(type + '=') == -1) {
              str = item.split('=')[1].toLowerCase();
              str = str.replace('main_', '');
          }
      }
  }
  return str;
}

export function getRules(rulesArr){  // 返回form表单验证配置：Rules
  // rules(){
  //   rulesArr :[
  //     {name: "字段名",type: "input",rules: [{required: true},{min:不写默认为0,max: 最大值}]},
  //     {name: "字段名",type: "select",rules: [{required: true}]},
  //     {name: "字段名",type: "checkbox",rules: [{type: 'array', required: true }]},
  //     {name: "字段名",type: "radio",rules: [{required: true}]},
  //   ];
  //   return this.$getRules(rulesArr)
  // }
  let obj = {};
  rulesArr.forEach(element => {
    let itemArr = [];
    if (element.type == "input") {
      element.rules.forEach(item=>{
        item["trigger"] = "blur";
        if("required" in item) item['message'] = this.$t(`customErrMsg.fieldIsRequired.${element.name}`);
        if("max" in item) {item['message'] = `Must be within ${item.max} characters`}
        itemArr.push(item);
      })
    } else if (['select','radio','checkbox'].includes(element.type)) {
      element.rules.forEach(item=>{
        item["trigger"] = "change";
        if ("required" in item && !("customText" in item)) item['message'] = this.$t(`customErrMsg.fieldIsRequired.${element.name}`);
        itemArr.push(item);
      })
    }
    obj[element.name] = itemArr;
  });
  return obj;
}

export function getCountries(countries){
  const removeArr=["AUS","BEL","CIV","GNB","ISR","LBR","MLI","NZL","STP","SLE","SGP","TZA","TLS","VEN","FRA","JPN","MOZ","POL","TJK","VUT","ZMB"];//需要移除的国家数目
  let obj={};
  for(let key in countries){
    if(!removeArr.includes(key)) obj[key] = countries[key];
  }
  return obj;
}

/**
 * 粗糙解决： element-ui el-select组件 多次点击 edge浏览器自动刷新 
 * @param {*} isVisible 
 */
export function elementuiSelect_Edge(isVisible) {
    const isEdge = window.navigator.userAgent.includes('Edge');
    if (isEdge && !isVisible) {
        document
            .querySelectorAll('body > .el-select-dropdown.el-popper')
            .forEach((it) => it.remove());
    }
}


// WEBPACK FOOTER //
// ./src/assets/js/uitl.js